import Lenis from '@studio-freight/lenis';
import Ukiyo from "ukiyojs";
import inAni from './inAni';

let lenis;

const scrollTo = (elem) => {
    lenis.scrollTo(elem, {duration: 2});
}

const init = () => {

    var sdlastScrollTop = 0;
    var sdScrollOffset = 150;
    let body = document.querySelector('body');
    let topCheckpoint = 200;
    
    // Lenis
    lenis = new Lenis();

    //get scroll value
    lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {

        // Scroll Direction
        if (scroll > (sdlastScrollTop + sdScrollOffset)) {
            body.classList.remove('isScroll--up');
            body.classList.add('isScroll--down');
            sdlastScrollTop = scroll <= 0 ? 0 : scroll; // For Mobile or negative scrolling
        } else if (scroll < (sdlastScrollTop - sdScrollOffset)) {
            body.classList.remove('isScroll--down');
            body.classList.add('isScroll--up');
            sdlastScrollTop = scroll <= 0 ? 0 : scroll; // For Mobile or negative scrolling
        }

        // Top Checkpoint
        if (scroll > topCheckpoint) {
            body.classList.add('topCheckpoint');
        } else {
            body.classList.remove('topCheckpoint');
        }

        inAni.refresh();
    
    })

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Ukiyo Parallax
    new Ukiyo(".ukiyo");

    const nextSection = document.querySelectorAll('.goToNextSection');

    if(nextSection){
        nextSection.forEach((item) => {

            item.addEventListener('click', function(e) {
                e.preventDefault();
                let nextSectionID = item.parentNode.offsetParent.nextElementSibling.getAttribute('id');
                item.setAttribute('href', '#'+nextSectionID);
            });
        });
    }


    const scrollItems = document.querySelectorAll('[href^="#"]');

    if(scrollItems.length > 0){
        scrollItems.forEach((item) => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                let target = item.getAttribute('href');

                if(target != '#'){
                    scrollTo(target);
                }
            });
        });
    }
};

export default {init, scrollTo};